import React, { useContext } from "react";
import { StoreContext } from "../../context/StoreContext";
import { useMatchMedia } from "../../util/useMatchMedia";
import { AppBar, Toolbar, Box, Typography } from '@mui/material';

const TopHeader = () => {
    const { data } = useContext(StoreContext);
    const storeDetails = data.store_master;
    const isMobile = useMatchMedia("(max-width: 576px)", true);
    return (
        <AppBar
            position="static"
            sx={{
                background: 'linear-gradient(90deg, #FF2200 0%, #FF8C00 100%)',
                color: 'white',
                borderBottom: '1px solid #eee',
                overflow: 'hidden', 
            }}
        >
            <Box className="marquee-container">
                <Typography variant="body1" className="marquee-text">
                    Avaliability in IN, Banglore, and Pondicherry | Order Booking Last day Oct-25-2025
                </Typography>
            </Box>
        </AppBar>
    );
};

export default TopHeader;
